import { Injectable } from '@angular/core';
import { Action, Store } from '@ngrx/store';

@Injectable()
export class DispatcherStore {
    public static store: Store<any>;
    constructor(data: Store<any>) {
        DispatcherStore.store = data;
    }
}

export class Dispatcher {
    public static fire(action: Action) {
        DispatcherStore.store.dispatch(action);
    }

    public static fireDynamic(type: string) {

        const action = {
            type: type
        };

        DispatcherStore.store.dispatch(action);
    }
}
